module.exports = __webpack_public_path__ + "img/b2bcef68c783c198e4e255ee303d2a78.png";